import { useLayoutEffect, useState } from "react";
import {
  subscribePixieToast,
  takePendingToast,
} from "@/modules/pixieWorkspace";

const VISIBLE_MS = 2600;
// Lets the Workspace move out of the way before the toast lands on the video.
const DELAY_MS = 450;

// A short note over the video when the viewer comes back from Pixie.
export default function PixieToast() {
  const [text, setText] = useState("");

  // componentDidMount / componentWillUnmount (layout phase, as the class ran).
  useLayoutEffect(() => {
    let timers: ReturnType<typeof setTimeout>[] = [];

    function clearTimers() {
      timers.forEach(clearTimeout);
      timers = [];
    }

    function onToast(next: string) {
      clearTimers();
      timers.push(
        setTimeout(() => {
          takePendingToast();
          setText(next);
          timers.push(setTimeout(() => setText(""), VISIBLE_MS));
        }, DELAY_MS),
      );
    }

    const unsubscribe = subscribePixieToast(onToast);
    const pending = takePendingToast();
    if (pending) {
      onToast(pending);
    }

    return () => {
      unsubscribe();
      clearTimers();
    };
  }, []);

  if (!text) {
    return null;
  }
  return (
    <div
      className='pixie-toast tw:pointer-events-none tw:absolute tw:top-[16px] tw:left-[50%] tw:z-6 tw:whitespace-nowrap tw:rounded-[999px] tw:p-[9px_16px] tw:[font-family:"DM_Sans","Helvetica","Arial",sans-serif] tw:text-[#fff] tw:text-[13px] tw:[background:rgba(28,28,28,0.9)] tw:[font-weight:500] tw:[transform:translateX(-50%)]'
      role="status"
    >
      {text}
    </div>
  );
}
